export default __webpack_public_path__ + "static/media/recruit-no-requistion.f716a380.svg";